import { Duration } from "luxon";
import type { FC, ReactNode } from "react";
import { RemoveFilterChip } from "./filterChip.js";
import type { TotalRecordingDurationCondition } from "./totalRecordingDurationCondition.js";

export interface TotalRecordingDurationFilterItemProps {
  value: TotalRecordingDurationCondition | null;
  onChange: (newValue: TotalRecordingDurationCondition | null) => void;
}

export const TotalRecordingDurationFilterItem: FC<
  TotalRecordingDurationFilterItemProps
> = (props) => {
  if (props.value === null) {
    return null;
  }

  return (
    <RemoveFilterChip onRemove={() => props.onChange(null)}>
      {renderCondition(props.value)}
    </RemoveFilterChip>
  );
};

function renderCondition(
  condition: TotalRecordingDurationCondition,
): ReactNode {
  const durationText = Duration.fromDurationLike({
    seconds: condition.value,
  })
    .rescale()
    .toHuman({ unitDisplay: "short" });

  switch (condition.operator) {
    case "<":
    case "<=":
      return `Under ${durationText}`;

    case ">":
    case ">=":
      return `Over ${durationText}`;

    default:
      return "Invalid condition";
  }
}
